export default {
  SET_TICKET(state, ticket) {
    state.data = ticket;
  },
};
